import type { Revision, RevisionPageDocument, RevisionPageLink } from '../../types';
import { mutations } from '../../utils';
import { isRevisionPageParent } from './guards';

/**
 * Get direct children for a page.
 */
export function getPageChildrenInRevision(
    revision: Revision,
    pageId: string
): Array<RevisionPageDocument | RevisionPageLink>;
export function getPageChildrenInRevision(
    revision: mutations.MutableData<Revision>,
    pageId: string
): mutations.MutableData<RevisionPageDocument | RevisionPageLink>[];
export function getPageChildrenInRevision(
    revision: mutations.MutableData<Revision>,
    pageId: string
): mutations.MutableData<RevisionPageDocument | RevisionPageLink>[] {
    const page = mutations.getIn(revision, ['pages', pageId] as const);
    if (!page) {
        throw new Error(`Page ${pageId} not found`);
    }

    if (!isRevisionPageParent(page)) {
        throw new Error('Page has no children');
    }

    return mutations.map(
        mutations.get(page, 'pages'),
        (pageId) =>
            mutations.getIn(revision, ['pages', pageId] as const) as mutations.MutableData<
                RevisionPageDocument | RevisionPageLink
            >
    );
}
